// extracted by css-extract-rspack-plugin
var _1 = "ob";
var _2 = "oj";
var _3 = "o";
var _4 = "e1";
var _5 = "fu";
var _6 = "oi";
var _7 = "lk";
var _8 = "e0";
export { _1 as "alertItem", _2 as "arrowContainer", _3 as "button", _4 as "description", _5 as "footer", _6 as "informationContentComponent", _7 as "innerContent", _8 as "title" }
